import { Component, ElementRef, HostListener } from '@angular/core';

import { BaseComponent } from 'app/shared/infrastructure/base.component'; // leaf import - do not revert to the barrel (app/shared/infrastructure), breaks ng test (circular dependency)
import { getInitials } from 'app/shared/utils/initials.util';

/**
 * Replaces baMainMenu.html's avatar dropdown. Same two actions as today, ported verbatim:
 * Change Password (routerLink) and Sign Out (authService.logout()).
 */
@Component({
    selector: 'app-shell-account-menu',
    templateUrl: './app-shell-account-menu.component.html',
    styleUrls: ['./app-shell-account-menu.component.scss'],
})
export class AppShellAccountMenuComponent extends BaseComponent {
    open = false;

    constructor(private readonly elementRef: ElementRef) {
        super();
    }

    /** Name shown beside the avatar; the initials are derived from it so the two never disagree. */
    get displayName(): string {
        return this.user?.name || this.user?.fullName || '';
    }

    get initials(): string {
        return getInitials(this.displayName) || 'U';
    }

    toggle(): void {
        this.open = !this.open;
    }

    close(): void {
        this.open = false;
    }

    onLogout(event: Event): void {
        event.preventDefault();
        this.authService.logout();
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        if (this.open && !this.elementRef.nativeElement.contains(event.target)) {
            this.close();
        }
    }
}
